module.exports = __webpack_public_path__ + "static/3xsafe-mobile-454998f0a2d65d61c69fb3086df99a35.png";